/**
 * Local development API proxy (see src/setupProxy.js).
 *
 * When enabled, the API base URLs become same-origin /api/* paths on the dev server, which forwards
 * them to the real APIs. The browser therefore never issues a cross-origin request and localhost
 * does not need to be on the API CORS allow-lists. Enabled by the *:proxy scripts in package.json;
 * off everywhere else, including every deployed build.
 */
const USE_API_PROXY = process.env.REACT_APP_USE_API_PROXY === 'true';

/** Must stay in sync with the route prefixes in src/setupProxy.js. */
const PROXY_PREFIX = {
  FREEDOM: '/api/freedom',
  SECURITY: '/api/security',
  LEARNING: '/api/learning',
};

/**
 * `directUrl` is also the target setupProxy.js mounts the prefix with, so an API the environment
 * does not configure keeps its previous undefined value rather than pointing at a prefix no route
 * serves - which would answer with the dev server's own HTML instead of failing.
 */
const apiUrl = (proxyPrefix: string, directUrl?: string) => (USE_API_PROXY && directUrl ? proxyPrefix : directUrl);

const fullApiUrl = apiUrl(PROXY_PREFIX.FREEDOM, process.env.REACT_APP_FREEDOM_API_URL);
const fullSecurityApiUrl = apiUrl(PROXY_PREFIX.SECURITY, process.env.REACT_APP_SECURITY_API_URL);
const fullLearningApiUrl = apiUrl(PROXY_PREFIX.LEARNING, process.env.REACT_APP_LEARNING_API_URL);

export default {
  fullApiUrl,
  fullSecurityApiUrl,
  fullLearningApiUrl,
};
